function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "131");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Icons",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1820.000000, -1100.000000)",
  id: "Group-2-Copy-10"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(1620.000000, 40.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-2-Copy-4",
  transform: "translate(180.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: 131,
  transform: "translate(20.000000, 1060.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-56",
  x: 0,
  y: 0,
  width: 20,
  height: 20
}), /*#__PURE__*/React.createElement("path", {
  d: "M18,1 L2,1 C0.9,1 0,1.9 0,3 L0,15 C0,16.1 0.9,17 2,17 L10,17 L10,15 L2,15 L2,5 L10,10 L18,5 L18,10 L20,10 L20,3 C20,1.9 19.1,1 18,1 Z M10,8 L2,3 L18,3 L10,8 Z",
  id: "Shape",
  fill: "#B1C3CC",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12,20 L12,18.0239044 L16.5466968,13.4767596 L18.5225978,15.4528552 L13.975901,20 L12,20 Z M19.1174927,14.8579017 L17.1415917,12.8818061 L17.7577329,12.2656042 C17.941867,12.0956175 18.1684937,12.0072244 18.4376128,12.000425 C18.7067319,11.9930589 18.9333586,12.081452 19.1174927,12.2656042 L19.7336338,12.8818061 C19.917768,13.0659584 20.0064357,13.2926073 19.9996369,13.561753 C19.9922715,13.8308986 19.9036038,14.0575476 19.7336338,14.2416999 L19.1174927,14.8579017 Z",
  id: "Shape",
  fill: "#B1C3CC",
  fillRule: "nonzero"
}))))));

var SvgEmailEdit = function SvgEmailEdit(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEmailEdit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/email_edit.c7d5a6ab.svg";
export { ForwardRef as ReactComponent };